module.exports = __webpack_public_path__ + "img/074-supervisor.11f5a9fc.png";